import clsx from "clsx";
import date from "date-and-time";

import getAddress from "../../utils/getAddress";
import { ICustomer } from "../../models/Customer/Customer";

interface CustomerListProps {
  customers: ICustomer[];
}

export function CustomerList({ customers }: CustomerListProps) {
  const statusClasses = {
    0: "text-gray-700 bg-gray-50 ring-gray-600/20",
    1: "text-red-600 bg-red-50 ring-red-500/10",
    2: "text-green-700 bg-green-50 ring-green-600/20",
  };

  const statusText = {
    0: "Archived",
    1: "Disabled",
    2: "Enabled",
  };

  return (
    <ul className="divide-y divide-gray-100">
      {customers?.slice(0, 3).map((customer) => (
        <li
          key={customer.name}
          className="flex items-center justify-between gap-x-6 py-5"
        >
          <div className="min-w-0">
            <div className="flex items-start gap-x-3">
              <p className="text-sm font-semibold leading-6 text-gray-900">
                {customer.name}
              </p>
              <p
                className={clsx(
                  statusClasses[customer.status],
                  "mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset",
                )}
              >
                {statusText[customer.status]}
              </p>
            </div>
            <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
              <p className="whitespace-nowrap">
                {getAddress({
                  line1: customer.line1,
                  line2: customer.line2,
                  line3: customer.line3,
                  line4: customer.line4,
                  town: customer.town,
                  locality: customer.locality,
                  postcode: customer.postcode,
                })}
              </p>
              <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                <circle r={1} cx={1} cy={1} />
              </svg>
              <p className="truncate">
                Onboarded{" "}
                {date.format(new Date(customer.created), "DD/MM/YYYY")}
              </p>
            </div>
          </div>
          <div className="flex flex-none items-center gap-x-4">
            <a
              href={`/customer/${customer.id}`}
              className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
            >
              View client<span className="sr-only">{customer.name}</span>
            </a>
            {/* <Menu as="div" className="relative flex-none">
              <MenuButton className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
                <span className="sr-only">Open options</span>
                <EllipsisVerticalIcon aria-hidden="true" className="h-5 w-5" />
              </MenuButton>
              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <MenuItem>
                  <a
                    href="#"
                    className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
                  >
                    Edit<span className="sr-only">, {project.name}</span>
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="#"
                    className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
                  >
                    Move<span className="sr-only">, {project.name}</span>
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="#"
                    className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
                  >
                    Delete<span className="sr-only">, {project.name}</span>
                  </a>
                </MenuItem>
              </MenuItems>
            </Menu> */}
          </div>
        </li>
      ))}
    </ul>
  );
}
